const UUID = '[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}';
const PROTECTED_REFERENCE_PATTERNS = [
  new RegExp(`^asset://${UUID}$`, 'i'),
  new RegExp(`^wersee-object://${UUID}$`, 'i'),
  /^storage:\/\/(?:course-content|course-videos|digital-downloads|digital-products)\//i,
  new RegExp(`/cdn/${UUID}(?:$|[/?#])`, 'i'),
  new RegExp(`/api/storage/objects/${UUID}/download(?:$|[/?#])`, 'i'),
  /\/storage\/v1\/object\/(?:public|sign|authenticated)\/(?:course-content|course-videos|digital-downloads|digital-products)\//i,
];

export const isProtectedListingReference = (value: string) =>
  PROTECTED_REFERENCE_PATTERNS.some((pattern) => pattern.test(value));

const safeHttpsUrl = (value: string) => {
  try {
    const parsed = new URL(value);
    if (parsed.protocol !== 'https:' || parsed.username || parsed.password || parsed.hash) return null;
    if (parsed.port && parsed.port !== '443') return null;
    return parsed;
  } catch {
    return null;
  }
};

/** External links are allowed for seller-authored link lessons, never storage grants. */
export const safeExternalListingContentUrl = (value: unknown) => {
  if (typeof value !== 'string' || isProtectedListingReference(value)) return null;
  return safeHttpsUrl(value)?.toString() || null;
};

const configuredOrigins = () => {
  const origins = new Set(['https://files.wersee.com']);
  for (const value of [
    import.meta.env.VITE_SUPABASE_URL,
    import.meta.env.VITE_WERSEE_FILES_SITE_URL,
  ]) {
    if (typeof value !== 'string' || !value.trim()) continue;
    const parsed = safeHttpsUrl(value);
    if (parsed) origins.add(parsed.origin);
  }
  return origins;
};

export const safeAuthorizedListingAssetUrl = (
  value: unknown,
  allowedOrigins = configuredOrigins(),
) => {
  if (typeof value !== 'string') return null;
  const parsed = safeHttpsUrl(value);
  if (!parsed || !allowedOrigins.has(parsed.origin)) return null;

  const gatewayPath = new RegExp(`^/api/storage/objects/${UUID}/download$`, 'i');
  if (gatewayPath.test(parsed.pathname)) {
    return parsed.searchParams.get('grant')?.trim() ? parsed.toString() : null;
  }

  const signedStoragePath = /^\/storage\/v1\/object\/sign\/(?:course-content|course-videos|digital-downloads|digital-products)\//i;
  if (signedStoragePath.test(parsed.pathname)) {
    return parsed.searchParams.get('token')?.trim() ? parsed.toString() : null;
  }
  return null;
};
